import { Card, CardType } from 'Models/Card';
import { Options } from 'Models/Questionnaires';

export const cardData: Card[] = [
    //Saver Cards
    new Card({
        CardId: '0',
        Type: CardType.Saver,
        Description: 'Fixed leaky faucet',
        CardValue: 100,
        ImageUrl: '/cards/Saver-04.jpg',
    }),
    new Card({
        CardId: '1',
        Type: CardType.Saver,
        Description: 'Upgrade to LED lights',
        CardValue: 200,
        ImageUrl: '/cards/Saver-02.jpg',
    }),
    new Card({
        CardId: '2',
        Type: CardType.Saver,
        Description: 'Upgrade to LED lights',
        CardValue: 200,
        ImageUrl: '/cards/Saver-01.jpg',
    }),
    new Card({
        CardId: '3',
        Type: CardType.Saver,
        Description: 'Hang clothes out to dry',
        CardValue: 300,
        ImageUrl: '/cards/Saver-03.jpg',
    }),
    new Card({
        CardId: '4',
        Type: CardType.Saver,
        Description: 'High-Efficiency showerhead',
        CardValue: 200,
        ImageUrl: '/cards/Saver-01.jpg',
    }),
    new Card({
        CardId: '5',
        Type: CardType.Saver,
        Description: 'High-Efficiency showerhead',
        CardValue: 200,
        ImageUrl: '/cards/Saver-01.jpg',
    }),
    new Card({
        CardId: '6',
        Type: CardType.Saver,
        Description: 'Fixed leaky faucet',
        CardValue: 100,
        ImageUrl: '/cards/Saver-04.jpg',
    }),
    new Card({
        CardId: '7',
        Type: CardType.Saver,
        Description: 'Upgrade to LED lights',
        CardValue: 200,
        ImageUrl: '/cards/Saver-02.jpg',
    }),
    new Card({
        CardId: '8',
        Type: CardType.Saver,
        Description: 'Upgrade to LED lights',
        CardValue: 200,
        ImageUrl: '/cards/Saver-02.jpg',
    }),
    new Card({
        CardId: '9',
        Type: CardType.Saver,
        Description: 'Hang clothes out to dry',
        CardValue: 300,
        ImageUrl: '/cards/Saver-03.jpg',
    }),
    new Card({
        CardId: '10',
        Type: CardType.Saver,
        Description: 'High-Efficiency showerhead',
        CardValue: 200,
        ImageUrl: '/cards/Saver-01.jpg',
    }),
    new Card({
        CardId: '11',
        Type: CardType.Saver,
        Description: 'High-Efficiency showerhead',
        CardValue: 200,
        ImageUrl: '/cards/Saver-01.jpg',
    }),

    //Waster Cards
    new Card({
        CardId: '12',
        Type: CardType.Waster,
        Description: 'Shower running',
        CardValue: 100,
        ImageUrl: '/cards/Wester-08.jpg',
    }),
    new Card({
        CardId: '13',
        Type: CardType.Waster,
        Description: 'TV on',
        CardValue: 100,
        ImageUrl: '/cards/Wester-06.jpg',
    }),
    new Card({
        CardId: '14',
        Type: CardType.Waster,
        Description: 'Lights on',
        CardValue: 100,
        ImageUrl: '/cards/Wester-01.jpg',
    }),
    new Card({
        CardId: '15',
        Type: CardType.Waster,
        Description: 'Fan running',
        CardValue: 100,
        ImageUrl: '/cards/Wester-09.jpg',
    }),
    new Card({
        CardId: '16',
        Type: CardType.Waster,
        Description: 'Oven',
        CardValue: 200,
        ImageUrl: '/cards/Wester-07.jpg',
    }),
    new Card({
        CardId: '17',
        Type: CardType.Waster,
        Description: 'Charger',
        CardValue: 200,
        ImageUrl: '/cards/Wester-05.jpg',
    }),
    new Card({
        CardId: '18',
        Type: CardType.Waster,
        Description: 'Dryer',
        CardValue: 200,
        ImageUrl: '/cards/Wester-04.jpg',
    }),
    new Card({
        CardId: '19',
        Type: CardType.Waster,
        Description: 'Refrigerator',
        CardValue: 300,
        ImageUrl: '/cards/Wester-03.jpg',
    }),
    new Card({
        CardId: '20',
        Type: CardType.Waster,
        Description: 'Air Conditioner running',
        CardValue: 300,
        ImageUrl: '/cards/Wester-02.jpg',
    }),
    new Card({
        CardId: '21',
        Type: CardType.Waster,
        Description: 'Shower running',
        CardValue: 100,
        ImageUrl: '/cards/Wester-08.jpg',
    }),
    new Card({
        CardId: '22',
        Type: CardType.Waster,
        Description: 'TV on',
        CardValue: 100,
        ImageUrl: '/cards/Wester-06.jpg',
    }),
    new Card({
        CardId: '23',
        Type: CardType.Waster,
        Description: 'Lights on',
        CardValue: 100,
        ImageUrl: '/cards/Wester-01.jpg',
    }),
    new Card({
        CardId: '24',
        Type: CardType.Waster,
        Description: 'Fan running',
        CardValue: 100,
        ImageUrl: '/cards/Wester-09.jpg',
    }),
    new Card({
        CardId: '25',
        Type: CardType.Waster,
        Description: 'Oven',
        CardValue: 200,
        ImageUrl: '/cards/Wester-07.jpg',
    }),
    new Card({
        CardId: '26',
        Type: CardType.Waster,
        Description: 'Charger',
        CardValue: 200,
        ImageUrl: '/cards/Wester-05.jpg',
    }),
    new Card({
        CardId: '27',
        Type: CardType.Waster,
        Description: 'Dryer',
        CardValue: 200,
        ImageUrl: '/cards/Wester-04.jpg',
    }),
    new Card({
        CardId: '28',
        Type: CardType.Waster,
        Description: 'Refrigerator',
        CardValue: 300,
        ImageUrl: '/cards/Wester-03.jpg',
    }),
    new Card({
        CardId: '29',
        Type: CardType.Waster,
        Description: 'Air Conditioner running',
        CardValue: 300,
        ImageUrl: '/cards/Wester-02.jpg',
    }),

    // Renewable cards
    new Card({
        CardId: '30',
        Type: CardType.Renewable,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/Renewable.jpg',
    }),
    new Card({
        CardId: '31',
        Type: CardType.Renewable,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/Renewable.jpg',
    }),
    new Card({
        CardId: '32',
        Type: CardType.Renewable,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/Renewable.jpg',
    }),
    new Card({
        CardId: '33',
        Type: CardType.Renewable,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/Renewable.jpg',
    }),

    // Fossil fuel cards
    new Card({
        CardId: '34',
        Type: CardType.FossilFuel,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/FossilFuels.jpg',
    }),
    new Card({
        CardId: '35',
        Type: CardType.FossilFuel,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/FossilFuels.jpg',
    }),
    new Card({
        CardId: '36',
        Type: CardType.FossilFuel,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/FossilFuels.jpg',
    }),
    new Card({
        CardId: '37',
        Type: CardType.FossilFuel,
        Description: '',
        CardValue: 400,
        ImageUrl: 'cards/FossilFuels.jpg',
    }),

    // Energy tips card

    new Card({
        CardId: '38',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/01.png',
        Questionnaire: {
            QuestionnaireId: '01',
            Question: 'Which air conditioning tips help save energy?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Close all doors and windows.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Close blinds or curtains to not let heat inside.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Keep the AC on when you leave the house.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Seal your windows and doors so cool air does not escape.',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '39',
        Type: CardType.Energy,
        Description: '',
        CardValue: 300,
        ImageUrl: 'cards/tipsCard/02.png',
        Questionnaire: {
            QuestionnaireId: '02',
            Question: 'What elements will help Hawaii reach 100% Clean Energy by 2045 (select all that apply)?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Microgrid',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Energy efficiency',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Natural gas',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Electrification of transportation',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '40',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/03.png',
        Questionnaire: {
            QuestionnaireId: '03',
            Question: 'Which washing technique will save the MOST energy?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Washing clothes on Hot',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Washing clothes on Cold',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Washing clothes on Warm',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '41',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/04.png',
        Questionnaire: {
            QuestionnaireId: '04',
            Question: 'Dusting your refrigerator\'s condenser coils save energy.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'False',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '42',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/05.png',
        Questionnaire: {
            QuestionnaireId: '05',
            Question: 'What is the best way to dispose off old CFL bulbs after use?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'At an e-cycle collection point',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'In your home garbage',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'In the ocean',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'At a friends house',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '43',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/06.png',
        Questionnaire: {
            QuestionnaireId: '06',
            Question: 'Fix leaky faucets: one drop each second can waste about ____ gallons of water per year!',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: '500 gallons',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: '900 gallons',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: '1,600 gallons',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '04',
                    Title: '2,200 gallons',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '44',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/07.png',
        Questionnaire: {
            QuestionnaireId: '07',
            Question: 'Does having a second refrigerator waste energy?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Yes',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'No',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Maybe',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '45',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/08.png',
        Questionnaire: {
            QuestionnaireId: '08',
            Question: 'Which method is most energy-efficient for drying your clothes?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Using an electric dryer',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Hanging them out to dry',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Drying them on the ‘heat’ dry-cycle in the dishwasher',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Putting them in a sauna',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '46',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/24.png',
        Questionnaire: {
            QuestionnaireId: '09',
            Question: 'An ENERGY STAR television is ___% more efficient than a non-ENERGY STAR television.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: '10%',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: '30%',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: '50%',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: '70%',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '47',
        Type: CardType.Energy,
        Description: '',
        CardValue: 300,
        ImageUrl: 'cards/tipsCard/09.png',
        Questionnaire: {
            QuestionnaireId: '10',
            Question: 'Which TWO methods are the most efficient for saving fuel when getting around?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Driving in a car alone',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Carpooling',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Riding a bike',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Flying in a plane',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '48',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/25.png',
        Questionnaire: {
            QuestionnaireId: '11',
            Question: 'Which THREE statements are true about running an efficient refrigerator?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Set refrigerator temperature to 37 - 40°F for the fresh food compartment.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Refrigerator coils should be dusted every six months.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'The refrigerator can be left open when you aren\'t in the room.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Refrigerator seals need to be airtight and can be tested with the dollar bill test.',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '49',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/11.png',
        Questionnaire: {
            QuestionnaireId: '12',
            Question: 'What are the most efficient ways to add light to a room? (select all that apply)',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Turn on the lights',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Sing “You Are My Sunshine”',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Raise or open the window shades',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Open the door to the outside',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '50',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/26.png',
        Questionnaire: {
            QuestionnaireId: '13',
            Question: 'When cooking on the stove, your pan should _______ .',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Be larger than the burner',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Match the burner size',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Smaller than the burner',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Does not matter',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '51',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/10.png',
        Questionnaire: {
            QuestionnaireId: '14',
            Question: 'Best ways to utilize natural cooling in your home. (select all that apply)',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Open windows',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Turn on your ceiling fans',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Crank up the AC',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Keep the freezer door open',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '52',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/19.png',
        Questionnaire: {
            QuestionnaireId: '15',
            Question: 'When is the best time to use electricity?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Before 5 pm and after 10 pm',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'From 5pm-10pm',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Does not matter',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'When it\'s raining',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '53',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/21.png',
        Questionnaire: {
            QuestionnaireId: '21',
            Question: 'What tips will save you energy and money while showering? (select all that apply)',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Install a high-efficiency showerhead.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Let the water warm up while playing with your puppy.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Limit showers to 5 minutes.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Turn off the water when you are not using it.',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '54',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/12.png',
        Questionnaire: {
            QuestionnaireId: '17',
            Question: 'Foiling your oven racks blocks the flow of hot air and lengthens cooking time.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'False',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '55',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/16.png',
        Questionnaire: {
            QuestionnaireId: '18',
            Question: 'Which lightbulb is the most energy-efficient?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Incandescent (old school) light bulb',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'LED (Light Emitting Diode)',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'CFL (Compact Fluorescent Lamp)',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '56',
        Type: CardType.Energy,
        Description: '',
        CardValue: 300,
        ImageUrl: 'cards/tipsCard/17.png',
        Questionnaire: {
            QuestionnaireId: '19',
            Question: 'Solar water heating can cut a home\'s energy bill by over one-third.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'False',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Maybe',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '57',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/18.png',
        Questionnaire: {
            QuestionnaireId: '20',
            Question: 'Where is the best location to thaw your food to help reduce energy costs?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'In the microwave',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'In the bathtub',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'On the counter top',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'In the refrigerator',
                    IsAnswer: true,
                }),
            ],
        },
    }),

    new Card({
        CardId: '58',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/20.png',
        Questionnaire: {
            QuestionnaireId: '21',
            Question: 'Which fact about ENERGY STAR appliances is False?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'They include energy-efficient refrigerators, dishwashers, clothes washers and dryers, air conditioners, and ceiling fans.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'They do not help homeowners reduce greenhouse gas emissions and limit energy waste.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'They deliver the same or BETTER performance as comparable appliance models while using LESS energy and saving MORE money.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'If they cost more than their less energy-efficient counterparts, buyers will recover their investment through lower utility bills within a reasonable period of time.',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '59',
        Type: CardType.Energy,
        Description: '',
        CardValue: 300,
        ImageUrl: 'cards/tipsCard/13.png',
        Questionnaire: {
            QuestionnaireId: '22',
            Question: 'Hawaii Energy is a program that helps island families and businesses reduce energy consumption and lower electricity bills.',
            Options: [
                new Options({
                    OptionId: '02',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '01',
                    Title: 'False',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '60',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/22.png',
        Questionnaire: {
            QuestionnaireId: '23',
            Question: 'How does a whole house fan work?',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'By pulling warm air out of your house.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'By blowing warm air into your house.',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'By picking up and spinning the entire house.',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '61',
        Type: CardType.Energy,
        Description: '',
        CardValue: 100,
        ImageUrl: 'cards/tipsCard/23.png',
        Questionnaire: {
            QuestionnaireId: '24',
            Question: 'It is important to xeriscape (landscape design requiring little or no irrigation) your yard to keep your home cool and water bill low.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'False',
                    IsAnswer: false,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Maybe',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '62',
        Type: CardType.Energy,
        Description: '',
        CardValue: 300,
        ImageUrl: 'cards/tipsCard/14.png',
        Questionnaire: {
            QuestionnaireId: '25',
            Question: 'What actions would help move Hawaii closer to 100% clean energy (select all that apply)',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'Sharing this game\'s tips with a friend or family member',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'Turning the lights off when you aren\'t in the room.',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '03',
                    Title: 'Taking shorter showers',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '04',
                    Title: 'Leaving the air conditioning running when no one is home',
                    IsAnswer: false,
                }),
            ],
        },
    }),

    new Card({
        CardId: '63',
        Type: CardType.Energy,
        Description: '',
        CardValue: 200,
        ImageUrl: 'cards/tipsCard/15.png',
        Questionnaire: {
            QuestionnaireId: '26',
            Question: 'Being energy-efficient can zap your energy bill in half and help save our planet.',
            Options: [
                new Options({
                    OptionId: '01',
                    Title: 'True',
                    IsAnswer: true,
                }),
                new Options({
                    OptionId: '02',
                    Title: 'False',
                    IsAnswer: false,
                }),
            ],
        },
    }),
];
